import { ManagerBase } from '@core/ManagerBase';
import type { ISaveManager } from '@core/interfaces';

/** Yerel kalıcı veri — Phase 3+ implementasyon */
export class SaveManager extends ManagerBase implements ISaveManager {
  protected onInitialize(): void {
    // Phase 3
  }

  protected onShutdown(): void {
    // Phase 3
  }
}
